package com.anjuros.website.templates.template6.sections

import androidx.compose.runtime.Composable
import com.anjuros.website.components.shared.AnjurosCopyright
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosCopyrightStyled
import com.anjuros.website.components.shared.CompanyDetailsType
import com.anjuros.website.templates.template1.util.Template1CompanyDetails
import com.anjuros.website.templates.template1.util.Template1Constants
import com.anjuros.website.templates.template1.util.Template1Constants.CLIENTS_EMAIL
import com.anjuros.website.templates.template6.modules.Template6Section
import com.anjuros.website.templates.template6.modules.Template6Theme
import com.anjuros.website.templates.template6.modules.getColor
import com.anjuros.website.templates.template6.styles.CompanyColorVar
import com.anjuros.website.templates.template6.styles.Template6LinkFooterContactButton
import com.anjuros.website.templates.template6.styles.Template6NavigationFooterItemStyle
import com.anjuros.website.templates.template6.styles.Template6NavigationItemStyle
import com.anjuros.website.templates.template6.util.ResKey
import com.anjuros.website.templates.template6.util.Template6CompanyDetails
import com.anjuros.website.templates.template6.util.Template6Constants
import com.anjuros.website.templates.template6.util.Template6Constants.CLIENTS_FACEBOOK_LINK
import com.anjuros.website.templates.template6.util.Template6Constants.CLIENTS_WA_LINK
import com.anjuros.website.templates.template6.util.Template6Constants.FONT_FAMILY
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun  Template6FooterSection(
    clickable: Boolean = true
){

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .backgroundColor(rgb(18, 24, 28))
            .padding(top = 70.px),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        val breakpoint = rememberBreakpoint()

        if(breakpoint>=Breakpoint.LG){
        Row(
            modifier = Modifier
                .fillMaxWidth(90.percent)
                .gap(20.px),
            verticalAlignment = Alignment.Top,
            horizontalArrangement = Arrangement.SpaceBetween
        ) {

            FooterBrand(modifier = Modifier.fillMaxWidth(30.percent))

            Box(modifier = Modifier.fillMaxWidth(30.percent)) {
                FooterColumn(
                    modifier = Modifier
                        .align(Alignment.Center),
                    title = ResKey.FOOTER_LINKS_TITLE,
                    items = Template6Section.entries,
                    clickable = clickable
                )
            }

            FooterContact(modifier = Modifier.fillMaxWidth(40.percent))

        }} else {
            Column(
                modifier = Modifier
                    .fillMaxWidth(90.percent)
                    .gap(20.px),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.SpaceBetween
            ) {

                FooterBrand(modifier = Modifier.fillMaxWidth(100.percent))

                FooterContact(modifier = Modifier.fillMaxWidth(100.percent))
                Box(modifier = Modifier.fillMaxWidth(100.percent)) {
                    FooterColumn(
                        modifier = Modifier
                            .align(Alignment.CenterStart),
                        title = ResKey.FOOTER_LINKS_TITLE,
                        items = Template6Section.entries,
                        clickable = clickable
                    )
                }

            }
        }

        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(1.px)
                .backgroundColor(rgba(255,255,255,.08))
                .margin(topBottom = 50.px)
        )

        FooterBottom()

    }
}

@Composable
private fun FooterBrand(modifier: Modifier) {

    Column(
        modifier = modifier
    ) {

        P(
            attrs = Modifier
                .fontSize(34.px)
                .fontWeight(FontWeight.Bold)
                .color(Colors.White)
                .margin(bottom = 20.px)
                .toAttrs()
        ) {
           AnjurosText(
               text = Template6CompanyDetails.CLIENTS_NAME_INFO
           )
        }

        P(
            attrs = Modifier
                .fontSize(17.px)
                .lineHeight(30.px)
                .color(rgb(185,185,185))
                .margin(bottom = 28.px)
                .toAttrs()
        ) {
            Text(LocalText(ResKey.TEMPLATE6_FOOTER_DESCRIPTION))
        }

        Row(
            modifier = Modifier.gap(16.px)
        ) {

            SocialIcon( icon = "template6_fb.svg",
                path = CLIENTS_FACEBOOK_LINK)

            SocialIcon( icon = "template6_wa.svg",
                path = CLIENTS_WA_LINK)

        }

    }

}

@Composable
private fun FooterContact(modifier: Modifier) {

    Column(
        modifier = modifier,
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.Start
    ) {

        FooterHeading(ResKey.FOOTER_CONTACT_TITLE)
        Link(
            modifier = Modifier
                .textDecorationLine(TextDecorationLine.None),
            path = "tel:${Template6Constants.CLIENTS_PHONE}",

            ) {
            FooterContactItem(
                modifier = Template6LinkFooterContactButton.toModifier(),
                icon = "template6_contact1.svg",
                text = Template6CompanyDetails.CLIENTS_PHONE_INFO
            )
        }
        Link(
            modifier = Modifier
                .textDecorationLine(TextDecorationLine.None),
            path = "mailto:${Template6Constants.CLIENTS_EMAIL}",

            ) {
            FooterContactItem(
                modifier = Template6LinkFooterContactButton.toModifier(),
                icon = "template6_contact2.svg",
                text = Template6CompanyDetails.CLIENTS_EMAIL_INFO
            )
        }
        FooterContactItem(
            modifier =  Modifier
                .color(rgb(185,185,185)),
            icon = "template6_contact3.svg",
            text = Template6CompanyDetails.CLIENTS_COMPANY_SERVICE_AREA_INFO
        )

        FooterContactItem(
            modifier =  Modifier
                .color(rgb(185,185,185)),
            icon = "template6_contact4.svg",
            text = Template6CompanyDetails.CLIENTS_COMPANY_OPENING_HOURS
        )

    }

}

@Composable
private fun FooterColumn(
    modifier: Modifier,
    title: ResKey,
    items: List<Template6Section>,
    clickable: Boolean = true
) {
    val color = Template6Theme.Secondary.getColor()

    Column(
        modifier = modifier,
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.Start
    ) {

        FooterHeading(title)

        items.forEach {

            Link(
                modifier = Modifier.fillMaxWidth()
                    .textDecorationLine(TextDecorationLine.None)
                ,
                path = if(clickable)it.path else ""
            ) {
                P(
                    attrs  = Template6NavigationFooterItemStyle.toModifier()
                        .fillMaxWidth()
                        .setVariable(CompanyColorVar,color)
                        .fontSize(17.px)
                        .margin(bottom = 16.px)
                        .cursor(Cursor.Pointer)
                        .toAttrs()
                ) {
                    Text(LocalText(it.title))
                }
            }

        }

    }

}

@Composable
private fun FooterHeading(
    title: ResKey
) {

    P(
        attrs = Modifier
            .fontSize(22.px)
            .fontWeight(FontWeight.Bold)
            .color(Colors.White)
            .margin(bottom = 24.px)
            .toAttrs()
    ) {
        Text(LocalText(title))
    }

}

@Composable
private fun FooterContactItem(
    modifier: Modifier = Modifier,
    icon: String,
    text: CompanyDetailsType
) {

    Row(
        modifier = Modifier
            .gap(14.px)
            .margin(bottom = 18.px)
            .alignItems(AlignItems.Center)
    ) {

        Image(
            modifier = Modifier.size(24.px),
            src = icon,
            alt = "current selection"
        )

        P(
            attrs = modifier
                .fontSize(17.px)
                .margin(0.px)
                .toAttrs()
        ) {
            AnjurosText(text)
        }

    }

}

@Composable
private fun SocialIcon(
    icon: String,
    path : String
) {

    Link(
        modifier = Modifier
            .textDecorationLine(TextDecorationLine.None),
        path = path,
        openExternalLinksStrategy =OpenLinkStrategy.IN_NEW_TAB

        ) {
        Box(
            modifier = Modifier
                .size(44.px)
                .backgroundColor(rgba(255, 255, 255, .08))
                .borderRadius(50.percent)
                .cursor(Cursor.Pointer),
            contentAlignment = Alignment.Center
        ) {

            Image(
                modifier = Modifier.size(30.px),
                src = icon,
                alt = "current selection"
            )

        }
    }
}

@Composable
private fun FooterBottom() {

    Row(
        modifier = Modifier
            .fillMaxWidth(90.percent)
            .padding(bottom = 30.px),
        horizontalArrangement = Arrangement.SpaceBetween
    ) {

        AnjurosCopyrightStyled(modifier = Modifier
            .fontSize(15.px)
            .color(rgb(145,145,145))
            .margin(0.px))

//        Row(
//            modifier = Modifier.gap(26.px)
//        ) {
//
//            P(
//                attrs = Modifier
//                    .fontSize(15.px)
//                    .color(rgb(145,145,145))
//                    .cursor(Cursor.Pointer)
//                    .margin(0.px)
//                    .toAttrs()
//            ) {
//                Text(LocalText(ResKey.FOOTER_PRIVACY))
//            }
//
//            P(
//                attrs = Modifier
//                    .fontSize(15.px)
//                    .color(rgb(145,145,145))
//                    .cursor(Cursor.Pointer)
//                    .margin(0.px)
//                    .toAttrs()
//            ) {
//                Text(LocalText(ResKey.FOOTER_TERMS))
//            }
//
//        }

    }

}
